import { FC, ReactNode } from "react";
import { Box, Typography } from "@mui/material";

import Row from "../../../ui/core/Row";
import ChevronRightIcon from "../../../icons/ChevronRightIcon";
import { getCardSx } from "./ediCardStyles";

// A clickable card for non-EDI content in the Claims & Remits list (log entries, warnings)
const SimpleNavCard: FC<{
  label: string;
  onClick: () => void;
  icon?: ReactNode;
  labelColor?: string;
}> = ({ label, onClick, icon, labelColor }) => (
  <Box
    onClick={onClick}
    role="button"
    tabIndex={0}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") onClick();
    }}
    sx={{ ...getCardSx("#E5E7EB"), py: 2.5 }}
  >
    <Row sx={{ alignItems: "center", gap: 1 }}>
      {icon}
      <Typography
        sx={{ fontSize: "0.8125rem", fontWeight: 600, color: labelColor }}
      >
        {label}
      </Typography>
    </Row>
    <ChevronRightIcon className="w-4 h-4 text-gray-400" />
  </Box>
);

export default SimpleNavCard;
